import { gql } from "@apollo/client";

export const UPDATE_CONTENT_BRANDS = gql`
  mutation authoring_updateContent(
    $input: authoring_ContentInputRequest
    $contenttype: authoring_ContentTypes!
  ) {
    authoring_updateContent(contentType: $contenttype, input: $input) {
      message
      path
      __typename
    }
  }
`;

export const UPDATE_SCHEMA_CONTENT_BRANDS = gql`
  mutation authoring_updateSchemaContent(
    $contentType: String
    $input: authoring_JSON
    $schema_document_type: String
  ) {
    authoring_updateSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
    }
  }
`;

// Same mutations the editors call from Publish — a share of an already-published item
// publishes again so the new brand takes effect on the live site.
export const PUBLISH_CONTENT_BRANDS = gql`
  mutation authoring_publishContent(
    $contentType: authoring_ContentTypes!
    $input: authoring_PublishInfo
  ) {
    authoring_publishContent(contentType: $contentType, input: $input) {
      parent_page_url
      message
      current_page_url
      __typename
    }
  }
`;

export const PUBLISH_SCHEMA_CONTENT_BRANDS = gql`
  mutation authoring_publishSchemaContent(
    $contentType: String
    $input: authoring_PublishData
    $schema_document_type: String
  ) {
    authoring_publishSchemaContent(
      contentType: $contentType
      input: $input
      schema_document_type: $schema_document_type
    ) {
      message
      path
      __typename
    }
  }
`;

export const BrandMutations = {
  UPDATE_CONTENT_BRANDS,
  UPDATE_SCHEMA_CONTENT_BRANDS,
  PUBLISH_CONTENT_BRANDS,
  PUBLISH_SCHEMA_CONTENT_BRANDS,
};
